import moment from 'moment';
import templateStr from 'text!./policy-billing-summary.html';

export default () => {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            title: '@',
            policyBillingSummary: '=',
            accountNumber: '@'
        },
        controller: ['$scope', '$state', '$stateParams', '$filter', 'InsuranceSuiteMetadata',
            ($scope, $state, $stateParams, $filter, InsuranceSuiteMetadata) => {
                $scope.loading = true;
                init();
                
                function init() {
                    if (angular.isDefined($scope.policyBillingSummary) && angular.isDefined($scope.policyBillingSummary.policyPeriodBillingSummaries)) {
                        createPolicyPeriodBillingSummaries($scope.policyBillingSummary);
                        $scope.paymentScheduleReturnMessage = $filter('translate')('gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.No payments scheduled for this policy');
                    }
                    $scope.loading = false;
                }

                function createPolicyPeriodBillingSummaries(policyBillingSummary) {
                    const now = moment();

                    if (!$scope.policyPeriodBillingSummaries) {
                        $scope.policyPeriodBillingSummaries = [];

                        policyBillingSummary.policyPeriodBillingSummaries.forEach((summary, index) => {
                            const policyPeriodBillingSummary = populateBillingSummaryData(summary, index, now);
                            $scope.policyPeriodBillingSummaries.push(policyPeriodBillingSummary);
                        });
                    }
                    
                    if (!$scope.currentPolicyPeriodBillingSummary) {
                        $scope.currentPolicyPeriodBillingSummary = defaultToRelevantPeriod(now);
                    }
                }

                function populateBillingSummaryData(summary, index, now) {
                    const policyPeriodBillingSummary = angular.copy(summary);

                    policyPeriodBillingSummary.periodName = `${index + 1}: ${summary.periodName}`;
                    policyPeriodBillingSummary.effectiveDate = summary.effectiveDate !== null && summary.effectiveDate !== undefined ? moment(summary.effectiveDate) : null;
                    policyPeriodBillingSummary.expirationDate = summary.expirationDate !== null && summary.expirationDate !== undefined ? moment(summary.expirationDate) : null;
                    policyPeriodBillingSummary.status = summary.isDelinquent === true ? $filter('translate')('gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.Delinquent') : $filter('translate')('gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.In Good Standing');
                    policyPeriodBillingSummary.billingMethod = summary.billingMethod ? InsuranceSuiteMetadata.get('pc').types.getTypelist('BillingMethod').getCode(summary.billingMethod).name : '-';
                    policyPeriodBillingSummary.alternativeBillingAccount = summary.alternativeBillingAccount || '-';
                    policyPeriodBillingSummary.invoiceStream = summary.invoiceStream || '-';
                    policyPeriodBillingSummary.pastDueAmount = summary.pastDueAmount;
                    policyPeriodBillingSummary.totalPremium = summary.totalPremium;
                    policyPeriodBillingSummary.taxesAndFees = summary.taxesAndFees;
                    policyPeriodBillingSummary.totalCosts = summary.totalCost;
                    policyPeriodBillingSummary.nextDueAmount = summary.nextDueAmount;
                    policyPeriodBillingSummary.nextDueDate = summary.nextDueDate;
                    policyPeriodBillingSummary.aggregatedPastDueAmount = summary.aggregatedPastDueAmount;
                    policyPeriodBillingSummary.pastDueDate = summary.pastDueDate;
                    policyPeriodBillingSummary.totalDueAmount = summary.totalDueAmount;
                    policyPeriodBillingSummary.showPastDueLine = policyPeriodBillingSummary.aggregatedPastDueAmount
                        && policyPeriodBillingSummary.aggregatedPastDueAmount.amount > 0;
                    policyPeriodBillingSummary.showCurrentPaymentLine = policyPeriodBillingSummary.nextDueAmount
                        && policyPeriodBillingSummary.nextDueAmount.amount > 0;

                    if (policyPeriodBillingSummary.invoices) {
                        policyPeriodBillingSummary.invoices.forEach((invoice) => {
                            updateInvoiceData(invoice);
                        });
                    }
                    
                    if (!$scope.currentPolicyPeriodBillingSummary &&
                            policyPeriodBillingSummary.effectiveDate &&
                            now.isAfter(policyPeriodBillingSummary.effectiveDate) &&
                            policyPeriodBillingSummary.expirationDate &&
                            now.isBefore(policyPeriodBillingSummary.expirationDate)) {
                        
                        policyPeriodBillingSummary.periodName += $filter('translate')('gateway.directives.PolicyCommissionsSummaryDirective. (Current)');
                        $scope.currentPolicyPeriodBillingSummary = policyPeriodBillingSummary;
                    }

                    return policyPeriodBillingSummary;
                }

                function defaultToRelevantPeriod(now) {
                    const lastIndex = $scope.policyPeriodBillingSummaries.length - 1;
                    if ($scope.policyPeriodBillingSummaries[lastIndex].expirationDate &&
                            now.isAfter($scope.policyPeriodBillingSummaries[lastIndex].expirationDate)) {
                        // If all periods are in the past, default to most recent (last in array)
                        return $scope.policyPeriodBillingSummaries[lastIndex];
                    }

                    // Else, all policies are in the future, default to soonest (first in array)
                    return $scope.policyPeriodBillingSummaries[0];
                }

                function updateInvoiceData(invoice) {
                    if (moment().isAfter(invoice.dueDate, ['year', 'month', 'day']) && invoice.unpaid.amount > 0) {
                        invoice.paidStatus = $filter('translate')('gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.Past Due');
                        invoice.showPastDueAlert = true;
                    } else {
                        invoice.showPastDueAlert = false;
                    }
                }

                $scope.$watch('policyBillingSummary', () => {
                    if (angular.isDefined($scope.policyBillingSummary) && angular.isDefined($scope.policyBillingSummary.policyPeriodBillingSummaries)) {
                        createPolicyPeriodBillingSummaries($scope.policyBillingSummary);
                        $scope.paymentScheduleReturnMessage = $filter('translate')('gateway.directives.PolicyBillingSummaryDirective.policy-billing-summary.No payments scheduled for this policy');
                    }
                });

            }]
    };
};